import axios from "axios";
import { loaderParser } from "./loader/index.mjs";
export default class Codex {
  constructor() {
    this.constant = {};
    this.language = {};
    this.raw = {};
    this.cacheSeconds = 300;
    this.__etags = {};
    this.__timeoutHandle = null;
    this.loading = new Promise((resolve, reject) => {
      this.__intialize = resolve;
    });
  }

  initialize(baseUrl) {
    this.baseUrl =
      baseUrl || "https://storage.googleapis.com/blu-constants-dev/";
    console.info(`Blu Codex initializing at ${this.baseUrl}...`);
    this.loading = this.fetchLibraries();
  }

  setCacheSeconds(cacheSeconds) {
    if (Number.isInteger(cacheSeconds) && cacheSeconds >= 0) {
      this.cacheSeconds = cacheSeconds;
    } else {
      throw new Error(
        "cacheSeconds must be a number greater than or equal to 0"
      );
    }
  }

  overload(dataType, data) {
    this[dataType] = data;
  }

  fetchLibraries() {
    const prom = [];
    Object.keys(loaderParser).forEach(async (fileName) => {
      const reqHeaders = {};
      if (this.__etags[fileName]) {
        // The If-None-Match header causes the server to return a 304 response
        // status if the file hasn't changed.
        reqHeaders["If-None-Match"] = this.__etags[fileName];
      }
      const req = axios
        .get(`${this.baseUrl}${loaderParser[fileName].url}`, {
          headers: reqHeaders,
        })
        .then((resp) => {
          this.__etags[fileName] = resp.headers["etag"];
          this.raw[fileName] = resp.data;
          this.overload(
            loaderParser[fileName].dataType,
            loaderParser[fileName].parser(resp.data)
          );
          console.info(
            `Loaded library: ${fileName} from ${this.baseUrl}${loaderParser[fileName].url}`
          );
        })
        .catch((error) => {
          // Handle errors by ignoring them.  They'll be retried anyway.
          // Note that 304 response statuses (Content not changed) are considered
          // an error, so this is a common code path.
          return undefined;
        });
      prom.push(req);
    });
    const newPromise = axios.all(prom).then(() => {
      if (this.__intialize) {
        this.__intialize();
        this.__intialize = null;
      }

      // Refetch after cache expires
      this.__timeoutHandle = setTimeout(() => {
        this.__timeoutHandle = null;
        this.fetchLibraries();
      }, this.cacheSeconds * 1000);
    });
    return newPromise;
  }

  onLoad() {
    if (this.loading) {
      return this.loading;
    } else {
      return Promise.resolve();
    }
  }

  close() {
    if (this.__timeoutHandle) {
      clearTimeout(this.__timeoutHandle);
      this.__timeoutHandle = null;
    }
  }
}
